
import React from "react";

const JinshazhouHospital = () => {
  return (
    <div className="max-w-7xl mx-auto p-4 md:p-8">

      {/* ----------------------- Images Section ----------------------- */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
        <img
          src="https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=800"
          alt="Hospital"
          className="rounded-xl w-full h-64 md:h-80 object-cover"
        />

        <img
          src="https://images.unsplash.com/photo-1576765607924-3ddc2325254c?w=800"
          alt="Hospital Reception"
          className="rounded-xl w-full h-64 md:h-80 object-cover"
        />
      </div>

      {/* ------------------------ Info Grid --------------------------- */}
      <div className="bg-white rounded-xl shadow-md border p-4 md:p-6 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">

        {/* Doctors */}
        <div className="text-center p-3 border rounded-xl">
          <p className="font-semibold text-gray-800">Doctors List</p>
          <button className="text-blue-500 font-medium text-sm mt-1">
            Click Here
          </button>
        </div>

        {/* Location */}
        <div className="text-center p-3 border rounded-xl">
          <p className="font-semibold text-gray-800">Location</p>
          <p className="text-gray-500 text-sm mt-1">Istanbul</p>
        </div>

        {/* Established */}
        <div className="text-center p-3 border rounded-xl">
          <p className="font-semibold text-gray-800">Established in</p>
          <p className="text-gray-600 text-sm mt-1">2000</p>
        </div>

        {/* Accreditation */}
        <div className="text-center p-3 border rounded-xl">
          <p className="font-semibold text-gray-800">Accreditations</p>
          <p className="text-yellow-600 font-semibold text-sm mt-1">JCI</p>
        </div>

        {/* Beds */}
        <div className="text-center p-3 border rounded-xl">
          <p className="font-semibold text-gray-800">Number of beds</p>
          <p className="text-gray-600 text-sm mt-1">1500</p>
        </div>

        {/* Specialty */}
        <div className="text-center p-3 border rounded-xl">
          <p className="font-semibold text-gray-800">Specialty</p>
          <p className="text-gray-600 text-sm mt-1">Multi Specialty</p>
        </div>

        {/* Images */}
        <div className="text-center p-3 border rounded-xl">
          <p className="font-semibold text-gray-800">Images</p>
          <button className="text-blue-500 font-medium text-sm mt-1">
            Click Here
          </button>
        </div>

        {/* Facilities */}
        <div className="text-center p-3 border rounded-xl">
          <p className="font-semibold text-gray-800">Facilities</p>
          <button className="text-blue-500 font-medium text-sm mt-1">
            Click Here
          </button>
        </div>
      </div>

      {/* ----------------------- Action Buttons ----------------------- */}
      <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
        <button className="bg-red-500 text-white px-6 py-3 rounded-xl shadow hover:bg-red-600">
          Book Appointment For Memorial Hospitals Group, Istanbul
        </button>

        <button className="bg-green-500 text-white px-6 py-3 rounded-xl shadow hover:bg-green-600">
          Whatsapp Us
        </button>
      </div>

      {/* -------------------------- About ----------------------------- */}
      <div className="mt-10">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">
          About Hospital
        </h2>

        <ul className="space-y-3 text-gray-700 leading-relaxed">
          <li className="flex gap-2">
            <span className="text-green-600 mt-1">✔</span>
            Founded with a mission to deliver world-class medical care with a
            focus on patient experience.
          </li>

          <li className="flex gap-2">
            <span className="text-green-600 mt-1">✔</span>
            First Hospital in Turkiye to receive JCI accreditation, setting a
            new standard for quality.
          </li>

          <li className="flex gap-2">
            <span className="text-green-600 mt-1">✔</span>
            Awarded the LEED Platinum certification for sustainable “green
            hospital” design.
          </li>

          <li className="flex gap-2">
            <span className="text-green-600 mt-1">✔</span>
            Treated over 120,000 international patients from 90+ countries
            annually.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default JinshazhouHospital;
